<div class='bems-loader-wrapper' id='bems-loader-wrapper'>
  <div class='bems-loader'>
      <svg class='circular' viewbox='25 25 50 50'>
      <circle class='path' cx='50' cy='50' fill='none' r='20' stroke-miterlimit='10' stroke-width='7'></circle>
      </svg>
  </div>
</div>
<div class="container-fluid bg-nav sticky-top header">
  <div class="">
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
            <a class="nav-button" routerLink="/admin/station" routerLinkActive="active-link">Station Monitor</a>
          </li>
          <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
            <a class="nav-button" routerLink="/admin/adminInfo" routerLinkActive="active-link">Admin</a>
          </li>
          <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
            <a class="nav-button" routerLink="/admin/tbSetting" routerLinkActive="active-link">TB Setting</a>
          </li>
        </ul>
        <ul class="nav justify-content-end">
          <li class="nav-item">
            <a class="nav-button" [matMenuTriggerFor]="menu">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 800 800">
                <path id="account_circle_FILL0_wght400_GRAD0_opsz48"
                  d="M222-255q63-44,125-67.5T480-346q71,0,133.5,23.5T739-255q44-54,62.5-109T820-480q0-145-97.5-242.5T480-820q-145,0-242.5,97.5T140-480q0,61,19,116T222-255ZM479.814-450Q422-450,382.5-489.686t-39.5-97.5Q343-645,382.686-684.5t97.5-39.5Q538-724,577.5-684.314t39.5,97.5Q617-529,577.314-489.5t-97.5,39.5Zm.654,370Q398-80,325-111.5t-127.5-86Q143-252,111.5-324.766T80-480.266Q80-563,111.5-635.5t86-127q54.5-54.5,127.266-86t155.5-31.5Q563-880,635.5-848.5t127,86q54.5,54.5,86,127.032t31.5,155Q880-398,848.5-325t-86,127.5Q708-143,635.468-111.5t-155,31.5ZM480-140a366.741,366.741,0,0,0,107.5-16Q640-172,691-212q-51-36-104-55a310.789,310.789,0,0,0-214,0q-53,19-104,55,51,40,103.5,56A366.741,366.741,0,0,0,480-140Zm0-370q34,0,55.5-21.5T557-587q0-34-21.5-55.5T480-664q-34,0-55.5,21.5T403-587q0,34,21.5,55.5T480-510ZM480-587ZM480-213Z"
                  transform="translate(-80 880)" fill="#fff61a" />
              </svg>
              <span>&nbsp;{{username}}&nbsp;</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="0.5em" height="0.25em" viewBox="0 0 400 199">
                <path id="arrow_drop_down_FILL0_wght400_GRAD0_opsz48" d="M480-360,280-559H680Z" transform="translate(-280 559)"
                  fill="#fff61a" />
              </svg>
            </a>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="logOut()">Logout</button>
            </mat-menu>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</div>